<template>
  <DoughnutChart :chartData="data" :options="options" />
</template>

<script>
import { mapGetters } from "vuex";
import { defineComponent } from "vue";
import { DoughnutChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default defineComponent({
  name: "GraficoMinhaContribuicao",
  components: { DoughnutChart },
  props: {
    chartdata: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      participante: "participante"      
    }),
    chartDataObj() {
      return this.chartdata;
    }
  },
  data() {
    return {
      segmento: null,
      data: null,
      label: [],
      options: {
        cutout: "88%",  // Ajuste para Chart.js 3.x+
        responsive: true,
        plugins: {
          legend: false,
          tooltip: false,
        },
        rotation: -90,  // -0.5 * Math.PI
        circumference: 180,  // 1 * Math.PI
      }
    }
  },
  mounted() {

    if (this.chartdata) {
      this.renderContribuicaoChart();
    }
  },  
  methods: {
    renderContribuicaoChart() {
      this.label.push(this.chartdata.label)
      if (Array.isArray(this.label) && Array.isArray(this.chartdata.data)) {
        this.data = {
          labels: this.label,
          datasets: [{
            data: this.chartdata.data,
            backgroundColor: this.chartdata.backgroundColor,
            borderWidth: this.chartdata.borderWidth,
            borderColor: this.chartdata.borderColor,
          }]
        };
      } else {
        console.error("chartdata.label ou chartdata.data não são arrays.");
      }
    }
  },
  watch: {
    chartdata(val) {
      this.renderContribuicaoChart();
    }
  }
});
</script>
